import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
//
import { customizeFeature } from '../utils/customize-feature';

const noop = () => {};

export const AudioPlayer = (props) => {
  const { url, onStart = noop } = props;
  const [playing, setPlaying] = useState(false);
  const feature = customizeFeature('speaker');
  const reactPlayerRef = useRef(null);

  useEffect(() => {
    if (!playing) {
      return;
    }

    onStart();
  }, [playing]);

  const handleTogglePlay = () => {
    setPlaying((prev) => {
      reactPlayerRef.current.seekTo(0);
      return !prev;
    });
  };

  const handleOnEnded = () => {
    setPlaying(false);
  };

  return (
    <div
      className={classNames('rdw-option-wrapper', feature.className, {
        'rdw-option-active': playing,
      })}
      onClick={handleTogglePlay}
    >
      <ReactPlayer
        style={{ display: 'none' }}
        ref={reactPlayerRef}
        controls={false}
        url={url}
        playing={playing}
        onEnded={handleOnEnded}
      />
      <img alt src={feature.icon} />
    </div>
  );
};

AudioPlayer.propTypes = {
  url: PropTypes.string.isRequired,
  onStart: PropTypes.func,
};
